import { render, staticRenderFns } from "./courseContentDelete.vue?vue&type=template&id=4b8010c5&"
import script from "./courseContentDelete.vue?vue&type=script&lang=js&"
export * from "./courseContentDelete.vue?vue&type=script&lang=js&"
import style0 from "./courseContentDelete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports